import * as React from "react";
import { SpaceBetween, Button } from "@amzn/awsui-components-react";

import { SPOOF_STORAGE_KEY, getStoredSpoof } from "../../api/common";

export const SpoofIdentityBanner = () => {
    const stored = getStoredSpoof();
    if (!stored) return null;

    const handleClear = () => {
        localStorage.removeItem(SPOOF_STORAGE_KEY);
        window.location.reload();
    };

    return (
        <div style={{ background: "#ff9900", padding: "8px 16px", color: "#000", textAlign: "center" }}>
            <SpaceBetween direction="horizontal" size="s">
                <span><strong>⚠️ Impersonating: {stored.id}</strong></span>
                <Button variant="link" onClick={handleClear}>Clear</Button>
            </SpaceBetween>
        </div>
    );
};
